// seedData.ts
// Demo/seed data for the application

export const seedFoldersCampaign = [
  { id: "fd_all", name: "All" },
  { id: "fd_onboarding", name: "Onboarding" },
  { id: "fd_promotions", name: "Promotions" },
  { id: "fd_lifecycle", name: "Lifecycle" },
];

export const seedFoldersAutomatic = [
  { id: "fd_all", name: "All" },
  { id: "fd_system", name: "System" },
  { id: "fd_behavioral", name: "Behavioral" },
];

export const seedNotifications = [
  {
    id: "n1",
    internalTitle: "Welcome series #1",
    internalDescription: "First step of onboarding",
    // Old fields (kept for backwards compatibility)
    header: "Welcome to the app",
    subtitle: "Let's get started",
    body: "We're glad you're here.",
    // New platform-specific fields
    androidTitle: "Welcome to the app",
    androidBody: "We're glad you're here.",
    iosTitle: "Welcome to the app",
    iosSubtitle: "Let's get started",
    iosBody: "We're glad you're here.",
    link: "app://home",
    folderId: "fd_onboarding",
    type: "automatic",
    webhook: "https://api.example.com/webhooks/onboarding",
    image: null,
    createdAt: Date.now() - 86400000 * 5,
  },
  {
    id: "n2",
    internalTitle: "Cart recovery",
    internalDescription: "Recover abandoned carts",
    // Old fields (kept for backwards compatibility)
    header: "You left something behind",
    subtitle: "Your cart misses you",
    body: "Tap to review your items.",
    // New platform-specific fields
    androidTitle: "You left something behind",
    androidBody: "Tap to review your items.",
    iosTitle: "You left something behind",
    iosSubtitle: "Your cart misses you",
    iosBody: "Tap to review your items.",
    link: "app://cart",
    folderId: "fd_behavioral",
    type: "automatic",
    webhook: "https://api.example.com/webhooks/cart",
    image: null,
    createdAt: Date.now() - 86400000 * 12,
  },
];